export const createUnitFields = /* GraphQL */ `
id
sk
name
maturity
workspaceId
tags {
  key
  type
  value
}
`;
